export const WIZARD_TOKENS = {
    accent: '#079EC2',
    accentLight: '#3DB5D2',
    accentSoft: '#6AC5DA',
    complete: '#379D00',
    text: '#424B5C',
    textMuted: '#9FA0A2',
    border: '#E3E7EA',
    borderInput: '#D1D1D1',
    surface: '#fff',
    primaryBg: '#6AC5DA',
    primaryHover: '#3DB5D2',
    primaryDisabled: '#EEEEEE',
    secondaryBorder: '#3DB5D2',
    secondaryBorderHover: '#079EC2',
    secondaryBorderDisabled: '#A7A8A9',
    linkText: '#3C66C4',
    destructiveBg: '#110FB4'
};

export const mergeTokens = (overrides) => ({ ...WIZARD_TOKENS, ...(overrides || {}) });
